/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 */
document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details

    // udpate price  - apparently the theme formatting functions are not avilable here so we have to do our own, US only
    var newPrice = new Intl.NumberFormat('en-us').format((variant.price * 0.01).toFixed(2));
    // update in sticky header
    var productStickyPrice = document.querySelector('.ProductStickyBar__Price.Price');
    productStickyPrice.textContent = '$' + newPrice;

    // update in product description
    var productDescriptionPrice = document.querySelector('.ProductForm__Price');
    productDescriptionPrice.innerHTML = '$' + newPrice;

    // These are added by theme, so we have to hack the CSS to make it like it doesn't happen
    // hiding price in the ProductMeta__PriceList Heading area through CSS since we don't ever want to display it
    // hiding price in ProductForm__AddToCart through CSS since we don't ever want to display it

});
/*
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* forms helpers - primarily for contact and registration forms */
function updateStateField() {
    var countryField = document.getElementById("country-dropdown");
    var countryCode = countryField.options[countryField.selectedIndex].value;

    //US
    if (countryCode == '230') {
        document.getElementById("state-dropdown").innerHTML = "<option value='' selected></option><option value='0' >Alabama</option><option value='1' >Alaska</option><option value='2' >Arizona</option><option value='3' >Arkansas</option><option value='53' >Armed Forces Americas</option><option value='52' >Armed Forces Europe</option><option value='54' >Armed Forces Pacific</option><option value='4' >California</option><option value='5' >Colorado</option><option value='6' >Connecticut</option><option value='7' >Delaware</option><option value='8' >District of Columbia</option><option value='9' >Florida</option><option value='10' >Georgia</option><option value='11' >Hawaii</option><option value='12' >Idaho</option><option value='13' >Illinois</option><option value='14' >Indiana</option><option value='15' >Iowa</option><option value='16' >Kansas</option><option value='17' >Kentucky</option><option value='18' >Louisiana</option><option value='19' >Maine</option><option value='20' >Maryland</option><option value='21' >Massachusetts</option><option value='22' >Michigan</option><option value='23' >Minnesota</option><option value='24' >Mississippi</option><option value='25' >Missouri</option><option value='26' >Montana</option><option value='27' >Nebraska</option><option value='28' >Nevada</option><option value='29' >New Hampshire</option><option value='30' >New Jersey</option><option value='31' >New Mexico</option><option value='32' >New York</option><option value='33' >North Carolina</option><option value='34' >North Dakota</option><option value='35' >Ohio</option><option value='36' >Oklahoma</option><option value='37' >Oregon</option><option value='38' >Pennsylvania</option><option value='39' >Puerto Rico</option><option value='40' >Rhode Island</option><option value='41' >South Carolina</option><option value='42' >South Dakota</option><option value='43' >Tennessee</option><option value='44' >Texas</option><option value='45' >Utah</option><option value='46' >Vermont</option><option value='47' >Virginia</option><option value='48' >Washington</option><option value='49' >West Virginia</option><option value='50' >Wisconsin</option><option value='51' >Wyoming</option>";
        document.getElementById("state-dropdown").disabled = false;
        document.getElementById("state-label").innerHTML = "State/Province/Territory *";
    }

    //Canada
    else if (countryCode == '37') {
        document.getElementById("state-dropdown").innerHTML = "<option value='' selected></option><option value='101'>Alberta</option><option value='102'>British Columbia</option><option value='103'>Manitoba</option><option value='104'>New Brunswick</option><option value='105'>Newfoundland</option><option value='107'>Northwest Territories</option><option value='106'>Nova Scotia</option><option value='108'>Nunavut</option><option value='109'>Ontario</option><option value='110'>Prince Edward Island</option><option value='111'>Quebec</option><option value='112'>Saskatchewan</option><option value='113'>Yukon</option>";
        document.getElementById("state-dropdown").disabled = false;
        document.getElementById("state-label").innerHTML = "State/Province/Territory *";
    }

    //Others
    else {
        document.getElementById("state-dropdown").innerHTML = "";
        document.getElementById("state-dropdown").disabled = true;
        document.getElementById("state-label").innerHTML = "State/Province/Territory";
    }
}

function updateZipField() {
    var countryField = document.getElementById("country-dropdown");
    var countryCode = countryField.options[countryField.selectedIndex].value;

    let requiredStar = " *";
    let zipLabel = document.querySelector('#zip-label');
    let noStarZip = zipLabel.innerHTML.replace(requiredStar, "");
    let withStarZip = noStarZip + requiredStar;

    //United Arab Emirates has no postal codes
    if (countryCode == '2') {
        document.getElementById("zip-field").disabled = true;
        document.getElementById("zip-field").value = '';
        zipLabel.innerHTML = noStarZip;
    } else {
        document.getElementById("zip-field").disabled = false;
        zipLabel.innerHTML = withStarZip;
    }
}

function formatDate() {
    var newFormat = "";
    var oldFormat = document.getElementById("purchase-date-field").value;
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!oldFormat.match(regEx)) {
        alert("Please put your date in the format of YYYY-MM-DD");
        return false;
    }
    var year = oldFormat.substring(0, oldFormat.indexOf('-'));
    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1);
    var month = oldFormat.substring(0, oldFormat.indexOf('-'));
    if (month.charAt(0) == '0') {
        month = month.substring(1);
    }
    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1);
    var day = oldFormat;
    if (day.charAt(0) == '0') {
        day = day.substring(1);
    }
    newFormat = month + "/" + day + "/" + year;
    document.getElementById("new-date").value = newFormat;
}

// Make sure all files attached to a form are under 10MB (NetSuite limit). See contact and registration forms.
function validateFileSizes() {
    let fileSizeOk = true;
    let totalFileSize = 0;
    let warningIcons = document.querySelectorAll('.files-warning');
    let attached_files = document.querySelectorAll('input[type=file]');

    for (let file of attached_files) {
        if (file.files.length > 0) {
            if (file.files[0].size > 10000000) {
                fileSizeOk = false;
                // alert('Files must be less than 10 MB. ' + file.files[0].name + ' is too big.');
            }
            totalFileSize = totalFileSize + file.files[0].size;
        }
    }

    // convert bytes to B, KB or MB
    let friendlyFileSize = returnFileSize(totalFileSize);
    let percentFileSize = Math.round((totalFileSize / 10000000) * 100);

    document.querySelector('#totalFileSize').innerText = friendlyFileSize;
    document.querySelector('#files-progress-bar').setAttribute('aria-valuenow', percentFileSize);
    document.querySelector('#files-progress-bar').style.width = Math.min(Math.floor(percentFileSize), 100) + '%';
    document.querySelector('#percent-file-size').innerText = percentFileSize + '%';

    // NS has a limit on the total of all files 
    if (totalFileSize > 10000000) {
        fileSizeOk = false;
        alert('Files must total less than 10 MB.');
        document.querySelector('#files-progress-text').classList.add('progressbar-error-text');
        document.querySelector('#percent-file-size').classList.add('progressbar-error-text');
        warningIcons.forEach((icon) => icon.classList.remove('hidden'));
        document.querySelector('#files-progress-bar').classList.add('progressbar-error');
    } else {
        fileSizeOk = true;
        document.querySelector('#files-progress-text').classList.remove('progressbar-error-text');
        document.querySelector('#percent-file-size').classList.remove('progressbar-error-text');
        warningIcons.forEach((icon) => icon.classList.add('hidden'));
        document.querySelector('#files-progress-bar').classList.remove('progressbar-error');
    }

    return fileSizeOk;
}

// format file size to B, KB, or MB (from MDN)
function returnFileSize(number) {
    if (number < 1024) {
        return number + 'bytes';
    } else if (number >= 1024 && number < 1048576) {
        return (number / 1024).toFixed(1) + 'KB';
    } else if (number >= 1048576) {
        return (number / 1048576).toFixed(1) + 'MB';
    }
}

// check that all uploaded files are proper format, takes an array of mime types like image/jpeg or application/pdf
// the file input field should have the same mime types in its "accept" parameter
// note that image/jpeg includes both .jpg and .jpeg file extensions
function validateFileFormat(acceptedTypes) {
    if (!acceptedTypes) {
        // no file types defined, assume all ok
        return true;
    }
    
    let stringFileTypes = 'Accepted file types: ';
    acceptedTypes.forEach((type) => {
        stringFileTypes += '.' + type.split('/')[1] + ', ';
        // for jpgs
        if (type == "image/jpeg") {
            stringFileTypes += '.jpg, ';
        }
    });
    stringFileTypes = stringFileTypes.slice(0,-2);
    
    let attached_files = document.querySelectorAll('input[type=file]');

    for (let file of attached_files) {
        if (file.files.length > 0) {
            if (!acceptedTypes.includes(file.files[0].type)) {
                alert("Incorrect file type. " + stringFileTypes);
                return false;
            } 
        }
    }
    return true;
}

function confirmEmail() {
    var email = document.getElementById("email-field").value;
    var confirmEmail = document.getElementById("confirm-email-field").value;
    if (email != confirmEmail) {
        alert('Email addresses do not match!');
        return false;
    }
    return true;
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateZip(zip) {
    var countryField = document.getElementById("country-dropdown");
    var countryCode = countryField.options[countryField.selectedIndex].value;

    switch (countryCode) {
        //US
        case '230':
        case 'US':
            return /^\d{5}$/.test(zip);
        //Canada
        case '37':
        case 'CA':
            return /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip);
        //Australia
        case '14':
        case 'AU':
            return /^\d{4}$/.test(zip);
        //Austria
        case '13':
        case 'AT':
            return /^\d{4}$/.test(zip);
        //Belgium
        case '20':
        case 'BE':
            return /^\d{4}$/.test(zip);
        //Bulgaria
        case '22':
        case 'BG':
            return /^\d{4}$/.test(zip);
        //Croatia
        case '98':
        case 'HR':
            return /^\d{5}$/.test(zip);
        //Cyprus
        case '55':
        case 'CY':
            return /^\d{4}$/.test(zip);
        //Czech Republic
        case '56':
        case 'CZ':
            return /^\d{6}$/.test(zip);
        //Denmark
        case '59':
        case 'DK':
            return /^\d{4}$/.test(zip);
        //Estonia
        case '64':
        case 'EE':
            return /^\d{5}$/.test(zip);
        //Finland
        case '70':
        case 'FI':
            return /^\d{5}$/.test(zip);
        //France
        case '75':
        case 'FR':
            return /^\d{5}$/.test(zip);
        //Germany
        case '57':
        case 'DE':
            return /^\d{5}$/.test(zip);
        //Hungary
        case '100':
        case 'HU':
            return /^\d{4}$/.test(zip);
        //Ireland
        case '102':
        case 'IE':
            return /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/.test(zip);
        //Israel
        case '103':
        case 'IL':
            return /^\d{7}$/.test(zip);
        //Italy
        case '110':
        case 'IT':
            return /^\d{5}$/.test(zip);
        //Latvia
        case '135':
        case 'LV':
            return /^([Ll][Vv][- ]{0,1})[0-9]{4}$/.test(zip);
        //Lithuania
        case '133':
        case 'LT':
            return /^([Ll][Tt][- ]{0,1}){0,1}\d{5}$/.test(zip);
        //Luxemborg
        case '134':
        case 'LU':
            return /^\d{4}$/.test(zip);
        //Mexico
        case '157':
        case 'MX':
            return /^\d{5}$/.test(zip);
        //Netherlands
        case '166':
        case 'NL':
            return /^\d{4}\s{0,1}[A-Za-z]{2}$/.test(zip);
        //New Zealand
        case '171':
        case 'NZ':
            return (/^\d{4}$/.test(zip));
        //Norway
        case '167':
        case 'NO':
            return (/^\d{4}$/.test(zip));
        //Poland
        case '179':
        case 'PL':
            return /^\d{2}[- ]{0,1}\d{3}$$/.test(zip);
        //Portugal
        case '184':
        case 'PT':
            return /^\d{4}$/.test(zip);
        //Romania
        case '189':
        case 'RO':
            return /^\d{5}$/.test(zip);
        //Russia
        case '190':
        case 'RU':
            return /^\d{6}$/.test(zip);
        //Slovakia
        case '201':
        case 'SK':
            return /^\d{3}\s?\d{2}$/.test(zip);
        //Slovenia
        case '199':
        case 'SI':
            return /^\d{4}$/.test(zip);
        //Spain
        case '68':
        case 'ES':
            return /^\d{5}$/.test(zip);
        //Sweden
        case '196':
        case 'SE':
            return /^\d{3}\s*\d{2}$/.test(zip);
        //Switzerland
        case '42':
        case 'CH':
            return /^\d{4}$/.test(zip);
        //Turkey
        case '222':
        case 'TR':
            return /^\d{5}$/.test(zip);
        //Ukraine
        case '227':
        case 'UA':
            return /^\d{5}$/.test(zip);
        //United Arab Emirates - no postal codes, should be empty
        case '2':
        case 'AE':
            return zip=='';
        //United Kingdom
        case '77':
        case 'GB':
          //   return /^[A-Za-z]{1,2}[\d]{1,2}([A-Za-z])?\s?[\d][A-Za-z]{2}$/.test(zip);
          return /^(\w{1,2}\d{1,2}\w?\s\d\w{1,2})$/.test(zip);
        //Vietnam
        case '238':
        case 'VN':
            return /^\d{6}$/.test(zip);
        // Invalid or not defined
        default:
            return false;
    }
  }

/* end forms helpers */

/* User account form helpers - primarily to deal with floating labels and avoiding
 *  placeholder text that creates repetition for screen readers 
 */

// this depends on input element being immediately before label element
document.addEventListener("DOMContentLoaded", function () {
    // user form label listeners to move label when field not empty
    document.querySelectorAll('.Form__FloatingLabel').forEach(function (item) {
        // check for value on load
        let field = item.previousElementSibling;
        if (field.value !== '') {
            item.classList.add('floatLabel');
        } else {
            item.classList.remove('floatLabel');
        }

        // check for value when changed
        field.addEventListener('input', function (e) {
            let label = e.target.nextElementSibling;
            if (this.value !== '') {
                label.classList.add('floatLabel');
            } else {
                label.classList.remove('floatLabel');
            }
        });
    });
});

/* end user account form helpers */

/* script for masterbuilt.app to direct to mobile app */
function getHostName() {
    var hostname = window.location.hostname;
    if (hostname.includes("masterbuilt.app") && window.location.pathname != "/pages/app-download") {
        return true;
    } else {
        return false;
    }
}

function getMobileOperatingSystem() {
    if (getHostName()) {
        //alert(getHostName());

        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return userAgent;
    }

}

function DetectAndServe() {
    if (getHostName()) {
        let os = getMobileOperatingSystem();
        //alert(os);

        if (os == "Android") {
            window.location.href = "https://play.google.com/store/apps/details?id=com.masterbuilt.masterbuilt&hl=en_US&gl=US";
        } else if (os == "iOS") {
            window.location.href = "https://apps.apple.com/us/app/masterbuilt/id895935056";
        } else if (os == "Windows Phone") {
            window.location.href = "https://masterbuilt.app/pages/app-download";
        } else {
            window.location.href = "https://masterbuilt.app/pages/app-download";
        }
    }
}
DetectAndServe();
/* end mobile redirection script */